import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import 'moment/locale/pt-br';
import InputCurrency, { currency2Float } from '~components/UI/InputCurrency';
import get from 'lodash/get';
import find from "lodash/find";
import Moment from 'react-moment';
import { orderBy } from 'natural-orderby';
import moment from 'moment';
import Attachments from '~/containers/Attachments';
import { DatePicker } from '~components/UI/DatePicker/Locale';
import { processInitialValue, formatLeadName, getFilename, getTaskColor } from './utils/leadFormatters';
import { useTaskManagement } from './hooks/useTaskManagement';
import { useIndicationManagement } from './hooks/useIndicationManagement';

import {
  Input,
  Button,
  Form,
  Row,
  Col,
  Drawer,
  Select,
  Modal,
  Tabs,
  InputNumber,
  Timeline,
  Tooltip,
  Icon,
  Rate,
  Radio,
  Switch,
  Collapse,
  Empty,
  Progress
} from 'antd';

import { Cod } from '~/components/UI';
import InputMask from '~components/UI/InputMask';
import * as drawerLeads from './actions';
import Download from '~/components/Components/Download';
import { CompanyTypes } from '~components/SelectWithAdd';

import {
  taxationTypes,
} from '~/_domains/customers/drawer/data';

import { estados } from '~/utils/states_cities.json';

import { removeCountryCodeFromPhone } from '~/utils/formatters';
import { IndicationsTab } from './Tabs/IndicationsTab';
import SocietarioTab from './Tabs/SocietarioTab';
import TaskModal from './Modals/TaskModal';
import { LostReasons, Acquisitions, Tags } from "~/components/SelectWithAdd";
import Tip from "~/components/Tip";
import { WhatsappIcon } from '~/icons/WhatsappIcon';
import { WhatsappLink, StyledCollapse } from './styles';
import { DrawerSkeleton } from './components/DrawerSkeleton';
import { FaBuilding, FaMapMarkerAlt, FaDollarSign, FaUsers, FaCog, FaFileInvoiceDollar, FaUser, FaClipboardList, FaCalendarAlt, FaTasks } from 'react-icons/fa';

var Option = Select.Option;
var TabPane = Tabs.TabPane;
var TextArea = Input.TextArea;
var Panel = Collapse.Panel;

var sectionFields = {
  // Lead tab sections
  contato: [
    { key: 'name', label: 'Nome' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Telefone' },
    { key: 'assigned_to', label: 'Responsável' }
  ],
  qualificacao: [
    { key: 'acquisition_id', label: 'Origem' },
    { key: 'necessity', label: 'Necessidade' },
    { key: 'tags', label: 'Tags' }
  ],
  status: [
    { key: 'registered_at', label: 'Data de Criação' },
    { key: 'proposal_sent', label: 'Proposta enviada' }
  ],
  // Empresa tab sections
  dados: [
    { key: 'identification_number', label: 'CNPJ' },
    { key: 'company_type_id', label: 'Atividade' },
    { key: 'type_taxation', label: 'Regime Tributário' }
  ],
  localizacao: [
    { key: 'state', label: 'Estado' },
    { key: 'city', label: 'Cidade' }
  ],
  financeiro: [
    { key: 'billing', label: 'Faturamento' },
    { key: 'nfs_input', label: 'NFs Entrada' },
    { key: 'nfs_output', label: 'NFs Saída' }
  ],
  estrutura: [
    { key: 'n_partners', label: 'Sócios' },
    { key: 'n_staffs', label: 'Funcionários' },
    { key: 'number_bills', label: 'Boletos' }
  ],
  sistema: [
    { key: 'tax_software', label: 'Sistema Fiscal' }
  ],
  honorarios: [
    { key: 'first_honorary', label: 'Honorário Abertura' },
    { key: 'honorary', label: 'Mensalidade' }
  ]
};

function getSectionCompletion(sectionKey, getFieldValue) {
  var fields = sectionFields[sectionKey] || [];
  var filled = 0;
  var missing = [];

  fields.forEach(function(field) {
    var value = getFieldValue(field.key);
    if (value !== undefined && value !== null && value !== '') {
      filled++;
    } else {
      missing.push(field.label);
    }
  });

  var percent = fields.length > 0 ? Math.round((filled / fields.length) * 100) : 0;
  return { percent: percent, filled: filled, total: fields.length, missing: missing };
}

function SectionHeader(props) {
  var icon = props.icon;
  var title = props.title;
  var sectionKey = props.sectionKey;
  var getFieldValue = props.getFieldValue;

  var completion = getSectionCompletion(sectionKey, getFieldValue);
  var tooltipContent = completion.percent === 100
    ? 'Seção completa!'
    : 'Faltam: ' + completion.missing.join(', ');

  return (
    <span style={{ fontWeight: 600, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <span>
        {icon}
        {title}
      </span>
      <Tooltip title={tooltipContent}>
        <Progress
          type="circle"
          percent={completion.percent}
          width={24}
          strokeWidth={10}
          strokeColor={completion.percent === 100 ? '#52c41a' : '#1890ff'}
          format={function() { return ''; }}
          style={{ marginRight: 24 }}
        />
      </Tooltip>
    </span>
  );
}

const DrawerLead = (props) => {
  const [loading, setLoading] = useState(false);
  const [cnpjLoading, setCnpjLoading] = useState(false);
  const [tabActive, setTabActive] = useState('1');
  const [status, setStatus] = useState();
  const [forceIsRevised, setForceIsRevised] = useState(false);
  
  // Use custom hooks for state management
  const {
    tasks,
    setTasks,
    taskModal,
    openTaskModal,
    closeTaskModal
  } = useTaskManagement();
  
  const {
    indications,
    setIndications,
    leadChoseNotToIndicate,
    setLeadChoseNotToIndicate,
    resetIndications
  } = useIndicationManagement();

  const {
    form,
    drawer = { data: {}, show: false, isLoadingDetails: false },
    handleClose,
    handleFetchDetails,
    user,
    users,
  } = props;

  var { getFieldDecorator, getFieldValue } = form;
  var { data = {} } = drawer;

  var filteredUsers = useMemo(function() {
    return users.filter(function(u) {
      return u.email !== 'suporte@contlabs.com.br';
    });
  }, [users]);

  var orderedTasks = useMemo(function() {
    return orderBy(tasks, [function(t) { return t.due_at; }, function(t) { return t.id; }], ['desc', 'desc'])
      .filter(function(task) { return !task.is_deleted; });
  }, [tasks]);

  useEffect(() => {
    setTasks(get(data, 'tasks', []));
    setIndications(get(data, 'indications', []));
    setLeadChoseNotToIndicate(get(data, 'chose_not_to_indicate', false));
  }, [data]);

  // Always fetch lead details when drawer opens with an ID
  useEffect(() => {
    if (drawer.show && data.id && drawer.isLoadingDetails && !data.name) {
      // Only fetch if we don't already have full lead details (check for name field)
      handleFetchDetails(data.id);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawer.show, data.id, drawer.isLoadingDetails]);

  const handleCreate = () => {
    const { data = {} } = drawer;
    setStatus(data.status);
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      setLoading(true);
      props.handleCreate({
        ...data,
        ...values,
        tasks,
        indications: leadChoseNotToIndicate ? [] : indications,
        chose_not_to_indicate: leadChoseNotToIndicate,
        status,
        source: 'panel'
      })
        .then(() => {
          closeDrawerLeads();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }


  const handleSave = () => {

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      setLoading(true);
      props.handleSave(get(data, 'id'), {
        ...values,
        tasks,
        indications: leadChoseNotToIndicate ?
          indications.filter((indication) => !indication.is_new) :
          indications,
        chose_not_to_indicate: leadChoseNotToIndicate,
        status,
        force_is_revised: forceIsRevised
      })
        .then(() => {
          closeDrawerLeads();
        })
        .finally(() => {
          setLoading(false);
        });
    });

  }

  const handleDelete = () => {
    const modal = Modal.confirm({
      title: 'Você realmente deseja excluir este lead?',
      content: 'Esta ação não poderá ser revertida.',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          const result = await props.handleDelete(data);
          
          // Close the confirmation modal
          modal.destroy();
          
        } catch (error) {
          console.error('Error deleting lead:', error);
          // Close the confirmation modal even on error
          modal.destroy();
        }
      }
    });
  }

  const handleFetchCNPJData = async (cnpj) => {
    if (!cnpj) return;
    
    // Clean CNPJ from any formatting
    const cleanCNPJ = cnpj.replace(/[^\d]/g, '');
    
    if (cleanCNPJ.length !== 14) {
      Modal.error({
        title: 'CNPJ Inválido',
        content: 'Por favor, informe um CNPJ válido com 14 dígitos.',
      });
      return;
    }

    try {
      setCnpjLoading(true);
      const response = await fetch(`https://api.opencnpj.org/${cleanCNPJ}`);
      
      if (response.status === 404) {
        Modal.warning({
          title: 'CNPJ não encontrado',
          content: 'Não foram encontradas informações para este CNPJ.',
        });
        return;
      }
      
      if (!response.ok) {
        throw new Error('Erro ao buscar dados do CNPJ');
      }
      
      const companyData = await response.json();
      
      // Update form fields with the fetched data
      const fieldsToUpdate = {};
      
      if (companyData.nome_fantasia) {
        fieldsToUpdate.name = companyData.nome_fantasia;
      } else if (companyData.razao_social) {
        fieldsToUpdate.name = companyData.razao_social;
      }
      
      if (companyData.logradouro && companyData.municipio && companyData.uf) {
        fieldsToUpdate.city = companyData.municipio;
        fieldsToUpdate.state = companyData.uf;
      }
      
      if (companyData.cnae_principal && companyData.cnae_principal.descricao) {
        // Store CNAE description for company type matching
        fieldsToUpdate.cnae_description = companyData.cnae_principal.descricao;
      }
      
      // Set the form fields
      form.setFieldsValue(fieldsToUpdate);
      
      Modal.success({
        title: 'Dados importados com sucesso!',
        content: `Empresa: ${companyData.razao_social || companyData.nome_fantasia || 'N/A'}`,
      });
      
    } catch (error) {
      console.error('Error fetching CNPJ data:', error);
      Modal.error({
        title: 'Erro ao buscar dados',
        content: 'Não foi possível buscar os dados do CNPJ. Tente novamente.',
      });
    } finally {
      setCnpjLoading(false);
    }
  }



  const closeDrawerLeads = () => {
    setTabActive('1');
    resetIndications();
    form.resetFields();
    handleClose();
  }
  return (
    <Drawer
      title={(data.id) ? <span>Editar Lead <Cod float="right">#CRM{data.id}</Cod></span> : 'Cadastrar Lead'}
      width={900}
      placement="right"
      onClose={closeDrawerLeads}
      maskClosable={false}
      visible={drawer.show}
      destroyOnClose={true}
      style={{
        height: '100%',
        overflow: 'auto',
        paddingBottom: 53,
      }}>
      <TaskModal
        visible={taskModal.isOpen}
        closeModal={closeTaskModal}
        data={taskModal.data}
        setTasks={setTasks}
      />
      {drawer.isLoadingDetails ? (
        <DrawerSkeleton />
      ) : (
        <Form layout="vertical">
        <Tabs
          type="card"
          activeKey={tabActive}
          onChange={(key) => setTabActive(key)}>
          <TabPane tab="Lead" key={1} forceRender={true}>
            <StyledCollapse
              defaultActiveKey={['contato']}
              expandIconPosition="right"
              bordered={false}
            >
              <Panel header={<SectionHeader icon={<FaUser style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Informações de Contato" sectionKey="contato" getFieldValue={getFieldValue} />} key="contato">
                <Row gutter={16}>
                  <Col span={16}>
                    <Form.Item label="Nome">
                      {getFieldDecorator('name', {
                        initialValue: get(data, 'name'),
                        rules: [{ required: true, message: 'Por favor informe o nome do lead!' }],
                      })(<Input placeholder="Nome do lead" />)}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label={<span>Responsável <Tip>Responsável pela prospecção do lead.</Tip></span>}>
                      {getFieldDecorator('assigned_to', {
                        initialValue: get(data, 'assigned_to') ? get(data, 'assigned_to') : user.id,
                        rules: [{ required: true, message: 'Por favor informe o responsável pelo lead!' }],
                      })(
                      <Select placeholder="Responsável">
                        {filteredUsers.map(user => (
                          <Option key={user.id} value={user.id}>{user.name}</Option>
                        ))}
                      </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Email">
                      {getFieldDecorator('email', {
                        initialValue: get(data, 'email'),
                      })(<Input placeholder="Email" />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Telefone">
                      {getFieldDecorator('phone', { initialValue: removeCountryCodeFromPhone(data.phone) })(
                        <InputMask
                          mask="(99) 9999tt999?"
                          formatChars={{ "9": "[0-9]", "t": "[0-9\-]", "?": "[0-9 ]" }}
                          maskChar={null}
                          placeholder="Telefone da empresa"
                          suffix={getFieldValue('phone') ?
                            <Tooltip title="Ir para o Whatsapp" placement="topRight">
                              <WhatsappLink href={`https://wa.me/55${getFieldValue('phone')}`} target="_blank">
                                <WhatsappIcon />
                              </WhatsappLink>
                            </Tooltip> : <span />
                          }
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaClipboardList style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Origem e Qualificação" sectionKey="qualificacao" getFieldValue={getFieldValue} />} key="qualificacao">
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label={<span>Origem <Tip>A origem é o canal que direcionou o lead até a sua empresa. Por exemplo: Seu site, blog, Instagram, entre outros. <br /><br/> Dica: Se a origem desejada não estiver na lista, adicione digitando no campo e em seguida clique em cadastrar.</Tip></span>}>
                        {getFieldDecorator("acquisition_id", {
                        initialValue: data ? data.acquisition_id : null,
                        })(
                          <Acquisitions />
                        )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={<span>Necessidade <Tip>Se preenchido, após positivar o lead será criado um ticket no societário automáticamente.</Tip></span>}>
                      {getFieldDecorator('necessity', { initialValue: get(data, 'necessity') })(
                        <Select placeholder="Necessidade">
                          <Option value={2}>Abertura de Empresa</Option>
                          <Option value={1}>Troca de contabilidade</Option>
                          <Option value={2}>Abertura de Empresa</Option>
                          <Option value={3}>Encerramento de empresa</Option>
                          <Option value={4}>BPO Financeiro</Option>
                          <Option value={6}>MEI {'>'} ME</Option>
                          <Option value={5}>Outros</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  {getFieldValue('necessity') === 5 && (
                    <Col span={24}>
                      <Form.Item label="Especifique">
                        {getFieldDecorator('necessity_obs', {
                          initialValue: get(data, 'necessity_obs'),
                        })(<Input placeholder="Especifique a necessidade" />)}
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={16}>
                    <Form.Item label={<span>Tags <Tip>Crie e agrupe leads utilizando tags customizáveis.</Tip></span>}>
                        {getFieldDecorator("tags", (get(data, 'tags', null) && get(data, 'tags', null).length > 0) ? {
                        initialValue: processInitialValue(get(data, 'tags', null))
                        }:{})(
                          <Tags />
                        )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label={<span>Último honorário pago</span>}>
                      {getFieldDecorator('last_accounting_honorary', {
                        initialValue: get(data, 'last_accounting_honorary'),
                        normalize: (value) => currency2Float(value)
                      })(
                        <InputCurrency />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaCalendarAlt style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Datas e Status" sectionKey="status" getFieldValue={getFieldValue} />} key="status">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="Data de Criação">
                      {getFieldDecorator('registered_at', {
                        initialValue: get(data, 'registered_at', false) ? moment(data.registered_at) : null
                      })(
                        <DatePicker />
                      )}
                    </Form.Item>
                  </Col>
                  {(data.stage === 3 || data.stage === 4) && (
                    <Col span={8}>
                      <Form.Item label="Data de conclusão">
                        {getFieldDecorator('last_column_updated_at', {
                          initialValue: get(data, 'last_column_updated_at', false) ? moment(data.last_column_updated_at) : null
                        })(
                          <DatePicker />
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  <Col span={8}>
                    <Form.Item label={<span>Motivo da perda <Tip>É o motivo pelo qual o lead informou que não fechará o contrato. <br /><br/> Dica: Se o motivo desejado não estiver na lista, adicione digitando no campo e em seguida clique em cadastrar.</Tip></span>}>
                        {getFieldDecorator("lost_reason", {
                        initialValue: get(data, 'lost_reason')
                        })(
                          <LostReasons />
                        )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Proposta enviada?">
                      {getFieldDecorator('proposal_sent', {
                        initialValue: get(data, 'proposal_sent', false),
                        valuePropName: 'checked'
                      })(
                        <Switch />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Revisado">
                      {getFieldDecorator('is_revised', {
                        initialValue: get(data, 'is_revised', false),
                        valuePropName: 'checked'
                      })(
                        <Switch onChange={(value) => setForceIsRevised(value)} />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={
                <span style={{ fontWeight: 600, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <FaClipboardList style={{ marginRight: 8, verticalAlign: 'middle' }} />
                    Observações
                  </span>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: 8, fontSize: 13, color: '#666', fontWeight: 400 }}>Potencial:</span>
                    {getFieldDecorator('rate', data.rate ? {
                      initialValue: data.rate
                    } : {})(
                      <Rate count={3} style={{ fontSize: 16 }} />
                    )}
                  </div>
                </span>
              } key="observacoes">
                <Form.Item label={null} style={{ marginBottom: 0 }}>
                  {getFieldDecorator('description', {
                    initialValue: get(data, 'description'),
                  })(
                    <TextArea
                      rows={6}
                      placeholder="Descreva informações relevantes sobre o lead, histórico de conversas, pontos de atenção..."
                      style={{ resize: 'vertical' }}
                    />
                  )}
                </Form.Item>
              </Panel>

              <Panel header={
                <span style={{ fontWeight: 600, fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <FaTasks style={{ marginRight: 8, verticalAlign: 'middle' }} />
                    Follow Up e Reuniões
                    {orderedTasks.length > 0 && <span style={{ marginLeft: 8, backgroundColor: '#1890ff', color: '#fff', borderRadius: 10, padding: '2px 8px', fontSize: 12, fontWeight: 500 }}>{orderedTasks.length}</span>}
                  </span>
                  <Button type="primary" size="small" icon="plus" onClick={function(e) { e.stopPropagation(); openTaskModal(); }}>Adicionar</Button>
                </span>
              } key="followup">
                {orderedTasks.length === 0 ? (
                  <Empty
                    description="Nenhum follow up ou reunião agendada"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    style={{ padding: '24px 0' }}
                  >
                    <Button type="primary" icon="plus" onClick={function() { openTaskModal(); }}>Agendar Follow Up</Button>
                  </Empty>
                ) : (
                  <Timeline>
                    {orderedTasks.map(function(task) {
                      return (
                        <Timeline.Item key={task.id} dot={<div className="ant-timeline-item-head" style={{
                          backgroundColor: getTaskColor(task.status),
                          left: '0',
                          top: '0'
                        }} />}>
                          <p style={{
                            marginBottom: '0px',
                            fontWeight: 600,
                            fontSize: '16px'
                          }}>{task.name} <Button type="link" icon="edit" onClick={function() { openTaskModal(task); }}></Button></p>
                          <Moment format={'DD/MM ddd' + (task.type === 2 ? ' [às] HH:mm [hrs]' : '')}>
                            {task.due_at}
                          </Moment>
                        </Timeline.Item>
                      );
                    })}
                  </Timeline>
                )}
              </Panel>
            </StyledCollapse>
          </TabPane>
          <TabPane tab="Empresa" key={2} forceRender={true}>
            <StyledCollapse
              defaultActiveKey={['dados', 'localizacao', 'financeiro', 'honorarios']}
              expandIconPosition="right"
              bordered={false}
            >
              <Panel header={<SectionHeader icon={<FaBuilding style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Dados da Empresa" sectionKey="dados" getFieldValue={getFieldValue} />} key="dados">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="CNPJ">
                      {getFieldDecorator('identification_number', { initialValue: get(data, 'identification_number') })(
                        <InputMask
                          mask="99.999.999/9999-99"
                          placeholder="CNPJ"
                          suffix={getFieldValue('identification_number') ? (
                            cnpjLoading ? (
                              <Icon type="loading" style={{ color: '#1890ff' }} />
                            ) : (
                              <Tooltip title="Buscar dados da empresa" placement="topRight">
                                <Icon
                                  type="search"
                                  style={{ cursor: 'pointer', color: '#1890ff' }}
                                  onClick={function() { handleFetchCNPJData(getFieldValue('identification_number')); }}
                                />
                              </Tooltip>
                            )
                          ) : <span />
                          }
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label={<span>Atividade <Tip>Dica: Se a atividade da empresa não estiver na lista, adicione digitando o nome da atividade e em seguida clique em cadastrar.</Tip></span>}>
                      {getFieldDecorator('company_type_id', { initialValue: get(data, 'company_type_id') })(
                        <CompanyTypes />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Regime Tributário">
                      {getFieldDecorator('type_taxation', { initialValue: get(data, 'type_taxation') })(
                        <Select placeholder="Selecione um tipo de tributação">
                          {taxationTypes.map(function(item, index) { return <Option key={index} value={item}>{item}</Option>; })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaMapMarkerAlt style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Localização" sectionKey="localizacao" getFieldValue={getFieldValue} />} key="localizacao">
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Estado">
                      {getFieldDecorator('state', { initialValue: get(data, 'state') })(
                        <Select
                          placeholder="Estado"
                          showSearch
                          optionFilterProp="children"
                          filterOption={function(input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }}
                        >
                          {estados.map(function(item, index) { return <Option key={index} value={item.sigla}>{item.nome}</Option>; })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Cidade">
                      {getFieldDecorator('city', { initialValue: get(data, 'city') })(
                        <Select
                          placeholder="Cidade"
                          showSearch
                          optionFilterProp="children"
                          filterOption={function(input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }}
                        >
                          {get(find(estados, { sigla: getFieldValue('state') }), 'cidades', []).map(function(item, index) { return <Option key={index} value={item}>{item}</Option>; })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaDollarSign style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Informações Financeiras" sectionKey="financeiro" getFieldValue={getFieldValue} />} key="financeiro">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label={<span>Faturamento <small>(mensal)</small></span>}>
                      {getFieldDecorator('billing', {
                        initialValue: get(data, 'billing'),
                        normalize: function(value) { return currency2Float(value); }
                      })(
                        <InputCurrency />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label={<span>NFs Entrada <small>(mensal)</small></span>}>
                      {getFieldDecorator('nfs_input', {
                        initialValue: get(data, 'nfs_input'),
                      })(
                        <InputNumber style={{ width: '100%' }} placeholder="Quantidade" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label={<span>NFs Saída <small>(mensal)</small></span>}>
                      {getFieldDecorator('nfs_output', {
                        initialValue: get(data, 'nfs_output'),
                      })(
                        <InputNumber style={{ width: '100%' }} placeholder="Quantidade" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaUsers style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Estrutura da Empresa" sectionKey="estrutura" getFieldValue={getFieldValue} />} key="estrutura">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="Quantidade de Sócios">
                      {getFieldDecorator('n_partners', {
                        initialValue: get(data, 'n_partners'),
                      })(
                        <InputNumber style={{ width: '100%' }} placeholder="Número de sócios" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Quantidade de Funcionários">
                      {getFieldDecorator('n_staffs', {
                        initialValue: get(data, 'n_staffs'),
                      })(
                        <InputNumber style={{ width: '100%' }} placeholder="Número de funcionários" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Quantidade de Boletos">
                      {getFieldDecorator('number_bills', { initialValue: get(data, 'number_bills') })(
                        <InputNumber style={{ width: '100%' }} placeholder="Número de boletos" />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaCog style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Sistema Fiscal" sectionKey="sistema" getFieldValue={getFieldValue} />} key="sistema">
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item label="Sistema Fiscal">
                      {getFieldDecorator('tax_software', {
                        initialValue: data.tax_software,
                      })(
                        <Radio.Group>
                          <Radio.Button value={0} size="small">SAT</Radio.Button>
                          <Radio.Button value={1} size="small">ECF</Radio.Button>
                        </Radio.Group>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>

              <Panel header={<SectionHeader icon={<FaFileInvoiceDollar style={{ marginRight: 8, verticalAlign: 'middle' }} />} title="Honorários e Valores" sectionKey="honorarios" getFieldValue={getFieldValue} />} key="honorarios">
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label={<span>Honorário de Abertura</span>}>
                      {getFieldDecorator('first_honorary', {
                        initialValue: get(data, 'first_honorary'),
                        normalize: function(value) { return currency2Float(value); }
                      })(
                        <InputCurrency />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={<span>Mensalidade</span>}>
                      {getFieldDecorator('honorary', {
                        initialValue: (function() {
                          var value = get(data, 'honorary');

                          if (!value) return '';

                          var numericValue = 0;

                          if (typeof value === 'number') {
                            numericValue = value;
                          } else if (typeof value === 'string') {
                            var cleanValue = value.replace(/R\$\s*/g, '').trim();

                            if (cleanValue.includes(',') && cleanValue.includes('.')) {
                              var parts = cleanValue.split(',');
                              var integerPart = parts[0];
                              var decimalPart = parts[1];
                              cleanValue = integerPart.replace(/\./g, '') + '.' + (decimalPart || '00');

                              var parsed = parseFloat(cleanValue);
                              if (parsed > 100000) {
                                numericValue = parsed / 100;
                              } else {
                                numericValue = parsed;
                              }
                            } else {
                              numericValue = parseFloat(cleanValue) || 0;
                            }
                          }

                          return numericValue;
                        })(),
                        normalize: function(value) { return currency2Float(value); }
                      })(
                        <InputCurrency />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label={<span>Honorário de Troca</span>}>
                      {getFieldDecorator('change_honorary', {
                        initialValue: get(data, 'change_honorary'),
                        normalize: function(value) { return currency2Float(value); }
                      })(
                        <InputCurrency />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </StyledCollapse>
          </TabPane>
          <TabPane tab="Indicações" key={3}>
            <IndicationsTab
              leadChoseNotToIndicate={leadChoseNotToIndicate}
              setLeadChoseNotToIndicate={setLeadChoseNotToIndicate}
              indications={indications}
              setIndications={setIndications}
            />
          </TabPane>
          {data.id && data.stage === 3 && (
          <TabPane tab="Societário" key={5} style={{ padding: 16 }}>
            <SocietarioTab
              dashTasks={get(data, 'dash_tasks', [])}
              dashTasksWithTrashed={get(data, 'dash_tasks_with_trashed', [])}
              stage={get(data, 'stage')}
              necessity={get(data, 'necessity')}
              leadId={get(data, 'id')}
            />
          </TabPane>
          )}
          {data.id && (
          <TabPane
            tab="Anexos"
            key={4}
            style={{ padding: 16 }}>
            <Attachments 
              source={'leads'}
              entity={data.id}
              initialFiles={[]}
            />
          </TabPane>
          )}
        </Tabs>
        </Form>
      )}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }}
      >
        {get(data, 'id') && !drawer.isLoadingDetails && (
          <Download url={`/leads/print/${data.id}`} filename={getFilename(data)}>
            <Button style={{ marginRight: 8 }} type="primary">
              <Icon type="printer" /> Imprimir
            </Button>
          </Download>
        )}
        {get(data, 'id') && !drawer.isLoadingDetails && (<Button onClick={handleDelete} type="danger" style={{ marginRight: '8px' }}>Deletar</Button>)}
        <Button
          style={{
            marginRight: 8,
          }}
          onClick={closeDrawerLeads}
        >
          Cancelar
        </Button>
        {(get(data, 'id')) && !drawer.isLoadingDetails && (
          <Button onClick={handleSave} type="primary" loading={loading}>Salvar</Button>
        )}
        {!get(data, 'id') && (
          <Button onClick={handleCreate} type="primary" loading={loading}>Cadastrar</Button>
        )}
      </div>
    </Drawer>
  )
}

const mapStateToProps = state => ({
  user: state.user,
  users: state.users,
  drawer: state.leads.drawer,
});

const mapDispatchProps = dispatch => ({
  handleClose: () => dispatch(drawerLeads.close()),
  handleCreate: (payload) => dispatch(drawerLeads.create(payload)),
  handleSave: (id, payload) => dispatch(drawerLeads.save(id, payload)),
  handleDelete: (payload) => dispatch(drawerLeads.remove(payload)),
  handleFetchDetails: (leadId) => dispatch(drawerLeads.fetchLeadDetails(leadId)),
});

export default connect(mapStateToProps, mapDispatchProps)(Form.create()(DrawerLead));